import { render } from "./MagentoProjects.vue?vue&type=template&id=941fde3e"
import script from "./MagentoProjects.vue?vue&type=script&lang=js"
export * from "./MagentoProjects.vue?vue&type=script&lang=js"

import "./MagentoProjects.vue?vue&type=style&index=0&id=941fde3e&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__